import { Outlet } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import "./style.css";

function Layout() {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: "100%",
      }}
    >
      <div style={{ width: "100%" }}>
        <Header />
        <div
          className="container-fluid px-0 body-content"
          style={{ marginTop: "0rem" }}
        >
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
